<template>
  <v-container>
    <v-navigation-drawer
      v-model="drawer"
      app
      v-if="$route.name != 'home'"
      width="270px"
      min-width="270px"
      max-width="270px"
      mobile-breakpoint="960"
      class="glass"
      tile
      height="100%"
    >
      <v-toolbar-title class="d-flex justify-center">
        <v-img
          :src="require('../../assets/logos/logo_horizontal.png')"
          max-width="150px"
          class="mt-2 mx-2"
          contain
        ></v-img>
      </v-toolbar-title>
      <v-list class="pa-0">
        <v-list-group
          link
          color="primary"
          no-action
          group="/cuenta/"
          v-if="userLogged"
        >
          <template v-slot:activator>
            <v-list-item-icon style="margin: 15px 25px 15px 0 !important">
              <v-icon color="primary">mdi-account-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                style="font-size: 1rem !important"
                class="nombre"
                >{{ nombreUsuario }}</v-list-item-title
              >
              <v-list-item-subtitle>{{ userRut }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <template v-slot:appendIcon>
            <v-icon style="margin-left: 0 !important">mdi-menu-up</v-icon>
          </template>

          <v-list-item
            v-for="child in cuenta.children"
            :key="child.name"
            link
            :to="{ name: 'cuenta', params: { ajuste: child.to } }"
          >
            <v-list-item-content>
              <v-list-item-title style="font-size: 0.85rem !important">
                {{ child.name }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon style="margin: 15px 25px 15px 0 !important">
              <v-icon small color="primary">{{ child.icon }}</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-divider class="my-0"></v-divider>

      <v-list nav class="py-0">
        <div v-for="(item, i) in items" :key="i">
          <v-list-item
            :disabled="userLogged.b_cambiar_clave"
            v-if="
              !item.subgroup &&
              (item.bit ? sideBarMenuBits[item.bit] : true) &&
              (item.dev ? (prod ? false : true) : true)
            "
            link
            :to="{
              name: item.to,
              params: item.param ? { [item.paramName]: item.param } : {}
            }"
            color="primary"
          >
            <v-list-item-icon style="margin: 15px 25px 15px 0 !important">
              <v-icon color="primary">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="font-size: 0.85rem !important">{{
              item.name
            }}</v-list-item-title>
          </v-list-item>

          <v-list-group
            v-else-if="item.subgroup"
            link
            :to="{ name: item.to }"
            color="primary"
            no-action
            append-icon="mdi-menu-up"
          >
            <template v-slot:activator>
              <v-list-item-icon style="margin: 15px 25px 15px 0 !important">
                <v-icon color="primary">{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </template>

            <v-list-item
              v-for="child in item.children"
              :key="child.name"
              link
              :to="{ name: items[1].to, params: { product: child.param } }"
            >
              <v-list-item-content>
                <v-list-item-title>{{ child.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </div>
      </v-list>

      <template v-slot:append>
        <v-toolbar-title class="d-flex justify-end">
          <v-img
            :src="require('../../assets/logos/perrito.png')"
            max-width="65px"
            class="mx-2"
            contain
          ></v-img>
        </v-toolbar-title>
        <div class="pa-2">
          <v-btn @click="logout" block color="error"> Cerrar Sesión </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import auth from "@/services/auth";
import conv from "@/utility/conversores";
import { formatterRut } from "chilean-formatter";
import io from "socket.io-client";

export default {
  metaInfo() {
    return {
      key: "sidebar-key"
    };
  },
  data: () => ({
    totalMenu: [
      { name: "Inicio", route: "ingresa" },
      { name: "Productos", route: "productos" },
      { name: "Beneficiarios Seguro Capital", route: "benCapital" },
      { name: "Simulador de créditos", route: "creditos" },
      { name: "Pagar Productos", route: "pagoweb" },
      { name: "Seguimiento de Crédito", route: "seguimiento" },
      { name: "Cuenta", route: "cuenta" }
    ],
    items: [
      { name: "Inicio", icon: "mdi-home", to: "ingresa" },
      {
        name: "Pagar Productos",
        icon: "mdi-account-credit-card",
        to: "pagoweb"
      },
      {
        name: "Cuenta Capital",
        icon: "mdi-account-cash",
        to: "productos",
        param: "cuenta-capital",
        paramName: "product"
      },
      {
        name: "Beneficiarios Capital",
        icon: "mdi-account-star",
        to: "benCapital"
      },
      {
        name: "Créditos",
        icon: "mdi-credit-card",
        to: "productos",
        param: "creditos",
        paramName: "product"
      },
      {
        name: "Próximos Pagos",
        icon: "mdi-cash-clock",
        to: "productos",
        param: "proximos-pagos",
        paramName: "product"
      },
      {
        name: "Seguimiento de Crédito",
        icon: "mdi-credit-card-clock",
        to: "seguimiento",
        bit: "b_creditos_firmar"
      },
      {
        name: "Simulador de Crédito",
        icon: "mdi-credit-card-sync",
        to: "creditos",
        bit: "b_mayor"
      }
    ],
    cuenta: {
      name: "Ajustes Cuenta",
      icon: "mdi-account-cog",
      to: "cuenta",
      children: [
        {
          name: "Cambiar Clave",
          to: "cambiar-clave",
          icon: "mdi-account-lock"
        },
        {
          name: "Certificado Socio",
          to: "certificado-socio",
          icon: "mdi-file-certificate"
        }
      ]
    },
    finalItems: [{ name: "Atención Socios", icon: "mdi-phone" }],
    socket: null
  }),
  computed: {
    ...mapState(["sideBarMenuBits", "parametros"]),
    prod() {
      return process.env.NODE_ENV === "production";
    },
    userRut() {
      return formatterRut(this.userLogged.rut);
    },
    userLogged() {
      return auth.getUserLogged();
    },
    nombreUsuario() {
      let nombre = this.userLogged.nombres.split(" ")[0];
      let apellido = this.userLogged.apellido_paterno.split(" ")[0];
      return conv.capitalizeString(nombre + " " + apellido);
    },
    ...mapGetters({
      drawerTest: "drawer"
    }),
    drawer: {
      get() {
        return this.drawerTest;
      },
      set(state) {
        this.switchDrawer(state);
        return state;
      }
    }
  },
  async mounted() {
    if (this.$route.name) {
      let ruta = this.$route.name;
      var indiceRuta = this.totalMenu.findIndex((item) => item.route === ruta);
      this.cambiarRuta(this.totalMenu[indiceRuta].name);
    }
    this.socket = io(process.env.VUE_APP_API_URL); // Escucha eventos desde el servidor
    console.log("Conexión Establecida");
    this.socket.on("updateParams", async () => {
      await this.setParametros();
      if (this.parametros.mantencion) this.$router.push("/mantencion");
    });
  },
  beforeDestroy() {
    console.log("Conexión Terminada");
    if (this.socket) {
      this.socket.disconnect();
    }
  },
  methods: {
    ...mapMutations(["cambiarRuta", "closeTimeout"]),
    ...mapActions(["switchDrawer", "setParametros"]),
    valida(bit) {
      if (bit) {
        return this.userLogged[bit];
      } else return true;
    },
    logout() {
      this.closeTimeout();
      auth.cerrarSesion();
    }
  },
  watch: {
    "$route.name": {
      handler(value) {
        var indiceRuta = this.totalMenu.findIndex(
          (item) => item.route === value
        );
        this.cambiarRuta(this.totalMenu[indiceRuta].name);
      },
      deep: true
    }
  }
};
</script>
<style scoped lang="css">
.glass {
  width: 100%;
  height: 100%;
  box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.189);
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
}
.transparente {
  background-color: transparent;
}

.nombre {
  white-space: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 18px;
}
</style>
